import React from 'react';
// import { TrustpilotWidget } from '../../common';
import styles from '../../../styles/components/forms/BookingForm.module.css';

const FormFooter = ({ 
    isDarkMode, 
    timeError, 
    onSubmit 
}) => {
    return (
        <div className="row pt-1 pr-0 pb-[2px] pl-[10px]">
            <div className="col-lg-6 submit-btn-container">
                <div className="d-flex flex-column">
                    <button 
                        className={styles['submit-btn']} 
                        type="submit"
                        aria-label="Submit booking form to proceed to next step"
                        aria-describedby="form-errors"
                    >
                        Next Step
                    </button>
                </div>
                {timeError && 
                    <div
                        id="form-errors"
                        className={`text-danger ${styles['error-message-container']}`}
                        style={{ minHeight: '20px', visibility: timeError ? 'visible' : 'hidden' }}
                        role="alert"
                        aria-live="polite">
                        {timeError ? 'Return date must be greater than pick up date.' : ' '}
                    </div>
                }
            </div>
            {/* <div className="col-lg-6">
                <div className="d-flex flex-column">
                    <div className="text-start mb-0">
                        <span className={`${styles.tpt} ${isDarkMode ? styles['tpt-dark'] : ''}`}> Our Customers say: </span>
                        <TrustpilotWidget />
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default FormFooter;
